import { AdminApiRoutes } from '@gr/core/admin-api-routes';
import { ApiRoutes } from '@gr/core/api-routes';
import type { AccountPlanDto, CreatePlanRequestDto, PlanAssignmentDto, PlanDto, UpdatePlanRequestDto } from '@gr/core/accounts/plans/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

/** PLAN-UC-1…5: тарифные планы, назначение, свой тариф. */
export class PlansApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<OperationResult<PlanDto[]>> {
    return this.http.get(AdminApiRoutes.plans.list);
  }
  create(input: CreatePlanRequestDto): Promise<OperationResult<PlanDto>> {
    return this.http.post(AdminApiRoutes.plans.list, input);
  }
  update(planId: string, input: UpdatePlanRequestDto): Promise<OperationResult<PlanDto>> {
    return this.http.patch(AdminApiRoutes.plans.byId(planId), input);
  }
  makeDefault(planId: string): Promise<OperationResult<PlanDto[]>> {
    return this.http.post(AdminApiRoutes.plans.makeDefault(planId));
  }
  assignments(): Promise<OperationResult<PlanAssignmentDto[]>> {
    return this.http.get(AdminApiRoutes.plans.assignments);
  }
  userPlan(userId: string): Promise<OperationResult<AccountPlanDto>> {
    return this.http.get(AdminApiRoutes.plans.userPlan(userId));
  }
  assign(userId: string, planId: string): Promise<OperationResult<AccountPlanDto>> {
    return this.http.put(AdminApiRoutes.plans.userPlan(userId), { planId });
  }
  mine(): Promise<OperationResult<AccountPlanDto>> {
    return this.http.get(ApiRoutes.plans.mine);
  }
}
